/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 44,
  image: "default-changelog-v2.png",
  title: "Storage Organization, Platform Enhancements",
  shortDescription: "We have released a new version of the Spheron platform, which includes a new type of organization called Storage which is designed for data management, and a couple of more improvements and fixes. Storage and Browser-Upload packages now work with the storage organization",
  description: "We have released a new version of the Spheron platform, which includes a new type of organization called Storage which is designed for data management, and a couple of more improvements and fixes. Storage and Browser-Upload packages now work with the storage organization",
  date: "Sept 9th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron"]
};
export const content = `
## Introducing the new Storage Dashboard
We're thrilled to introduce a new organization type called "Storage" to elevate your data management experience. The Storage organization comes equipped with specialized tools and features tailored for efficient data handling.

### Buckets - Your Data's Best Friend

- Buckets represent the cornerstone of the Storage organization. They allow you to group and organize your uploads logically. Within each bucket, you can attach custom domains, enabling seamless data sharing via your preferred domain names. Furthermore, you can create IPNS (InterPlanetary Name System) records to exercise finer control over accessibility.

### Uploads - Managing Your Data, Made Easy

- Uploads represent individual pieces of your uploaded data. As mentioned, you can associate uploads with custom domains and IPNS records to enhance accessibility.

### Simplified IPFS Gateway Management

- As part of this transition, we've relocated IPFS Dedicated Gateways to the Storage organization. If you have existing IPFS Dedicated Gateways, rest assured we've smoothly migrated them for you.

### Free Membership

- Exciting news! Membership in the Storage organization is absolutely free for the Starter Plan, ensuring that you can leverage powerful data management tools without any financial commitment in the beginning.

### Important Compatibility Changes

Starting with version \`>=2.0.0\` of [@spheron/storage](https://www.npmjs.com/package/@spheron/storage) and [@spheron/browser-upload](https://www.npmjs.com/package/@spheron/browser-upload), there will be a significant change in compatibility. The >=2.0.0 SDK will exclusively work with our platform's new 'Storage' organization type.

Here's what you need to know:

### 1. Existing SDK Users (Version \`<2.0.0\`):

- If you are currently using SDK versions \`<2.0.0\`, you can continue to use these versions with the 'Static Site' organization until December 31st, 2023.

- On December 31st, 2023, the SDK versions \`<2.0.0\` will be officially deprecated for all organization types. To ensure continued compatibility and access to the latest features, we strongly recommend upgrading to SDK version \`>=2.0.0\` and transitioning your 'Static Site' organizations to the new 'Storage' type.

### 2. New 'Static Site' Organizations:

- Starting immediately, new 'Static Site' organizations will not be compatible with any version of the SDK, including \`<2.0.0\`. We encourage you to create 'Storage' organizations to utilize our SDK.

### Action Required:

- If you are currently using SDK versions \`<2.0.0\` and wish to continue using our SDK beyond December 1st, 2023, please plan to upgrade to SDK version\` >=2.0.0\` and transition your 'Static Site' organizations to the new 'Storage' type.
- Check out the [Documentation](https://docs.spheron.network/sdk/storage-v2/#changes-between-200-and-200) for more information regarding the migration.

## Platform improvements & fixes

- **Plan Information Enhancement:** Plan summary cards have been upgraded to provide you with more valuable information. You can now easily see the member count and available bandwidth for each plan, helping you make informed choices.
- **Compute Nomenclature:** Manual scaling is now referred to as On Demand, and No scaling is now labeled as Spot.
- **Early Access for On-Demand Compute:** You can now access On-Demand compute types through our early access program. Just click the "Get Early Access" button and connect with the team to understand the feature in-depth and get access to it.
- **Payment Notification Issue:** Fixed the issue that the new member payment notification was being sent even though the membership was free.
- **Web-App Renamed to Static Site:** We've updated the terminology from "Organization type Web-App" to "Static Site" across the entire platform and documentation.
- **Dropdown Display Fix:** Fixed the issue where the Organization's username was displayed instead of the Organization's name in the dropdown menu.
- **Fixed Price Consistency in Compute Deployer:** Our team has addressed price consistency issues within the compute deployer, ensuring that you have a seamless experience when deploying resources.
- **Compute Instance Updates Fixed:** We've tackled a bug that prevented Compute Instance Updates from working in certain edge cases. You can now confidently manage your compute instances with ease.
- **Expanded Docker Instance Configurations:** We've broadened your options by adding additional configurations for docker instances to our marketplace template instances. Customize your setup to suit your unique needs.
- **Alpha Tag Removal from Compute:** Say goodbye to the "Alpha" tag! We've removed it from the Compute section in the switch app dropdown, indicating that it's now a mature and fully supported feature.

`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
